import { Box, styled } from "@mui/material";

export const StyledBox = styled(Box)({
  background: "#FFFFFF",
  boxShadow:
    "0px 6px 10px rgba(0, 0, 0, 0.12), 0px 1px 18px rgba(0, 0, 0, 0.06)",
  borderRadius: "4px",

  "& .react-datepicker": {
    zIndex: 3,
    marginTop: "3.2rem",
    padding: "15px",
    position: "absolute",
    boxShadow:
      "0px 6px 10px rgba(0, 0, 0, 0.12), 0px 1px 18px rgba(0, 0, 0, 0.06)",
    "& .react-datepicker__month-container": {
      "& .react-datepicker__header": {
        background: "#fff",
        borderBottom: "none",
        "& .react-datepicker__current-month": {
          fontSize: "1.6rem",
          color: "#58595B",
        },
      },
    },
    "& .react-datepicker__navigation-icon::before": {
      borderColor: "#58595B",
    },
    "& .react-datepicker__navigation": {
      top: 20,
      borderColor: "none",
    },
  },

  "& .react-datepicker__day": {
    fontSize: "13px",
    fontFamily: "Open Sans",
    fontWeight: "400",
    width: "40px",
    height: "30px",
    margin: "4px 0px",
    borderRadius: "0px",
    paddingTop: "4px",
  },

  "& .react-datepicker__day-names": {
    fontWeight: "700",
    fontSize: "12px",
    marginTop: "20px",
  },

  "& .react-datepicker__day-name": {
    color: "#58595B",
    width: "auto",
    padding: "0 6px",
  },

  "& .react-datepicker__day--in-range": {
    background: "#E8E9EB",
    color: "#58595B",

    "&:first-of-type": {
      borderRadius: "16px 0px 0px 16px",
    },
    "&:last-child": {
      borderRadius: "0px 30px 30px 0px",
    },
  },
  "& .react-datepicker__day--range-start": {
    paddingTop: "4px",
    width: "40px",
    height: "30px",
    fontWeight: "bold",
    background: "#FFFFFF",
    color: "#CC3D3D !important",
    borderRadius: "30px 0px 0px 30px",
    filter: `drop-shadow(0px 1px 3px rgba(0, 0, 0, 0.06)) drop-shadow(0px 3px 5px rgba(0, 0, 0, 0.08))`,
    boxShadow:
      "0px 3px 5px rgba(0, 0, 0, 0.08), 0px 1px 3px rgba(0, 0, 0, 0.06)",
  },
  "& .react-datepicker__day--range-end": {
    paddingTop: "4px",
    width: "40px",
    height: "30px",
    fontWeight: "bold",
    background: "#FFFFFF",
    color: "#CC3D3D !important",

    borderRadius: "0px 30px 30px 0px",
    filter: `drop-shadow(0px 1px 3px rgba(0, 0, 0, 0.06)) drop-shadow(0px 3px 5px rgba(0, 0, 0, 0.08))`,
    boxShadow:
      "0px 3px 5px rgba(0, 0, 0, 0.08), 0px 1px 3px rgba(0, 0, 0, 0.06)",
  },
  "& .react-datepicker__day--keyboard-selected": {
    backgroundColor: "#FFFFFF",
    color: "#58595B",
  },
  "& .react-datepicker__day--in-selecting-range": {
    background: "#8C8D8F!important",
    color: "#FFF!important",
    "&:first-of-type": {
      borderRadius: "16px 0px 0px 16px",
    },
    "&:last-child": {
      borderRadius: "0px 30px 30px 0px",
    },
  },
});
